import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {Organization} from 'app_api/me/types';

import {template} from './template';
import css from './index.inline.styl';

export interface CreateProjectModalAttrs {
  'organization-id': number;
  'project-id': number;
  open: boolean;
  orgs: Organization[];
  'is-setup': boolean;
}

export class CreateProjectModal extends Component<EmptyObj, CreateProjectModalAttrs> {
  static get attrsSchema(): any {
    return {
      ...super.attrsSchema,
      'organization-id': {type: `number`, description: `id for current organization`},
      'project-id': {type: `number`},
      open: {type: `boolean`, description: `whether or not its open`},
      orgs: {type: `json`},
      'is-setup': {type: `boolean`, description: `from setup page or not`},
    };
  }
  get config() {
    return {
      css,
      defaultState: {},
      useShadowDom: true,
      template,
    };
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.attr(`is-setup`)) {
      mixpanel.track(`[Set Up] Project Create Modal Opened`);
    }
  }
}

export const CreateProjectModalEl = defineAndMakeJsxFactory(`mp-create-project-modal`, CreateProjectModal);
export const CreateProjectModalReact = panel2react(`mp-create-project-modal`, CreateProjectModal);
